import { Button } from 'components/ui/Button';
import { useTranslation } from 'react-i18next';
import s from './LoginPage.module.scss';

import useLogin from 'hooks/use-login';
import { CertificateSelector } from 'modules/certificates';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectCurrentCertificate, selectIsSignLoading } from 'store/reducers/certificates';
import { DemoModeMark, LoadingCertificates } from 'components/demo-mode-mark';
import { useState } from 'react';

export function CertificateForm() {
  const { t } = useTranslation();
  const { login, isClientLoading } = useLogin();
  const [isLoading, setIsLoading] = useState(true);
  const currentCertificate = useSelector(selectCurrentCertificate());
  const isSignLoading = useSelector(selectIsSignLoading());

  const location = useLocation();

  const handleSubmitClick = async () => {
    await login();
  };

  return (
    <div style={{ flex: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CertificateSelector onLoaded={() => setIsLoading(false)} />

      <DemoModeMark style={{ position: undefined, marginTop: 40, width: '100%' }} />
      <LoadingCertificates isLoading={isLoading} />

      <div className={s.buttonContainer}>
        <Button
          
          className={s.button}
          onClick={handleSubmitClick}
          disabled={!currentCertificate || isSignLoading || isClientLoading}
        >
          {t(isSignLoading ? 'Loading...' : 'enter')}
        </Button>
      </div>
    </div>
  );
}
